import { ScreenBackButton } from '$tablet-app/src/app/components/ScreenBackButton';
import { ScreenHeader } from '$tablet-app/src/app/components/ScreenHeader';
import { ScreenTitle } from '$tablet-app/src/app/components/ScreenTitle';
import { useCurrentProfile } from '$tablet-app/src/app/users';
import { Button } from '@akin-home/buttons/native';
import { Text } from '@akin-home/text/native';
import { colors, spacing } from '@akin-home/theme';
import { Linking, StyleSheet, View } from 'react-native';

interface Props {
  url: string;

  onLeave?(): void;
}

export const VideoCallScreen = (props: Props) => {
  const { url, onLeave } = props;

  const { profile } = useCurrentProfile();
  const handleContinue = () => {
    Linking.openURL(url + '?autojoin=' + profile.name);
  };

  return (
    <View style={styles.screen}>
      <ScreenHeader style={styles.screenHeader}>
        <ScreenBackButton onPress={onLeave} />
        <ScreenTitle>{'Video Call'}</ScreenTitle>
      </ScreenHeader>

      <View style={styles.container}>
        <View style={styles.innerContainer}>
          <Text variant="h2">Your video call will open in a new tab</Text>
          <Button size="large" onPress={handleContinue}>
            Join Video Call
          </Button>
        </View>

        <View style={styles.innerContainer}>
          <Text variant="h3">
            Invite other people to this call by sharing this link with them.
          </Text>
          <View style={styles.linkContainer}>
            <Text variant="p" style={styles.linkText}>
              {url}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
  },
  screenHeader: {
    gap: 20,
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  container: {
    flex: 1,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing[9],
    paddingBottom: spacing[6],
  },
  innerContainer: {
    gap: spacing[4],
    alignItems: 'center',
  },
  linkContainer: {
    borderWidth: 1,
    borderRadius: 10,
    backgroundColor: colors.grey[200],
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing[1],
    padding: spacing[2],
  },
  linkText: {
    textAlignVertical: 'center',
    textAlign: 'center',
  },
});
